<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData">
      <!-- <template #handle>
        <el-form-item>
          <el-button  v-show="authList.includes('robot:show')" v-if="userInfo.internalUser && !standard" type="primary" plain @click="setOtaIsShow">{{$t('equipment.robot.showOTA')}}</el-button>
        </el-form-item>
      </template> -->
    </Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <!-- <el-table-column prop="robotId" :label="$t('eIoT.transmit.taskId')"/> -->
      <!-- <el-table-column v-if="userInfo.internalUser" prop="robotModel" :label="$t('eIoT.transmit.robotModel')" /> -->
      <el-table-column prop="robotSn" :label="$t('eIoT.transmit.robotCode')" />
        <!-- <template #default="scope">
          <span v-if="scope.row.cabNo?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabNo)">{{scope.row.cabNo}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabNo}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template> -->
      <!-- </el-table-column> -->
      <el-table-column prop="robotName" :label="$t('eIoT.transmit.robotName')">
        <template #default="scope">
          {{ scope.row.robotName || scope.row.robotSn }}
        </template>
      </el-table-column>
        <!-- <template #default="scope">
          <span v-if="scope.row.cabNo?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabNo)">{{scope.row.cabNo}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabNo}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column> -->
      <el-table-column prop="fileName" :label="$t('eIoT.transmit.dataPackageName')" />
      <el-table-column prop="fileSize" :label="$t('eIoT.transmit.size')">
        <template #default="scope">
          {{ `${scope.row.fileSize} MB` }}
        </template>
      </el-table-column>
      <el-table-column prop="uploadMethod" :label="$t('eIoT.deviceConfig.uploadMethod')">
        <template #default="scope">
          <!-- 上传方式，0-直联，1-边端 -->
         <el-tag v-if="scope.row.uploadMethod">{{$t('eIoT.deviceConfig.edgeEndpoint')}}</el-tag>
         <el-tag v-else type="success">{{$t('eIoT.deviceConfig.directConnection')}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="edgeCode" :label="$t('eIoT.deviceConfig.edgeCode')" />
      <el-table-column prop="uploadStatus" :label="$t('eIoT.transmit.uploadStatus')">
        <template #default="{ row }">
          <el-tag v-if="row.uploadStatus == 1" type="info">
            <i class="el-icon-video-pause"></i>
            {{$t('eIoT.transmit.waitingForUpload')}}
          </el-tag>
          <div v-if="row.uploadStatus == 2" style="display: flex;align-items: center;">
            <el-progress type="circle" :percentage="65" :width="60" :stroke-width="4"></el-progress>
            <!-- 上传状态：0-等待上传, 1-上传中, 2-上传成功, 3-上传失败 -->
            <div style="margin-left: 12px;">
              <el-tag>
                <i class="el-icon-loading"></i>
                {{$t('eIoT.transmit.uploading')}}
              </el-tag>
            </div>
          </div>
          <el-tag v-if="row.uploadStatus == 3" type="success">
            <i class="el-icon-success"></i>
            {{$t('eIoT.transmit.uploadSuccess')}}
          </el-tag>
          <el-tag v-if="row.uploadStatus == 4" type="danger">
            <i class="el-icon-error"></i>
            {{$t('eIoT.transmit.uploadFailed')}}
          </el-tag>
          <el-tag v-if="row.uploadStatus == 5" type="danger">
            <i class="el-icon-delete"></i>
            {{'本地文件已删除'}}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column prop="updateTime" :label="$t('collect.healthscorelist.updateTime')"/> -->
      <!-- <el-table-column :label="$t('activity.list.operation')" width="100" fixed="right">
        <template #default="{ row }">
          <el-tooltip class="item" effect="dark" :content="$t('eIoT.transmit.viewDetails')">
            <i @click="editRobot(row)" class="iconfont icon-ota-eyeopen" :style="`color: ${row.edgeLinkStatus ? '#2E7D32' : '#9E9E9E' };font-size: 21px`"></i>
          </el-tooltip>
        </template>
      </el-table-column> -->
    </Table>
    <el-dialog v-model="dialogFormVisible" top="5vh" destroy-on-close :modal="true" :append-to-body="true">
      <el-form ref="formRef" class="dialog-form" :model="form" :rules="formRules" :label-width="curLang == 'zh-CN' ? '120px' : curLang == 'en-US' ? '165px' : '180px'">
        <el-form-item :label="$t('activity.packetjoin.robotCode')" prop="robotId">
          <el-input v-model="form.robotId"></el-input>
        </el-form-item>
        <el-form-item :label="$t('collect.healthscorelist.ctrlCabCode')" prop="cabNo">
          <el-select v-model="form.cabNo" :disabled="!!form.ota" :placeholder="$t('collect.healthscorelist.ctrlCabCode')" :remote-method="cabinetQuery" filterable remote clearable>
            <el-option
              v-for="(item) in cabinetList"
              :key="item.cabinetId"
              :label="item.cabinetId"
              :value="item.cabinetId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('status.largescreenm.robotName')">
          <el-input v-model="form.robotName" :placeholder="$t('status.largescreenm.enterRobotName')" />
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.robotLocation')">
          <el-row>
            <el-col :span="6">
              <el-select v-model="form.country" :placeholder="$t('equipment.cabinet.country')">
                <el-option
                  v-for="item in countryList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.province" :placeholder="$t('equipment.cabinet.province')">
                <el-option
                  v-for="item in provinceList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.city" :placeholder="$t('equipment.cabinet.city')">
                <el-option
                  v-for="item in formCityList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="form.area" :placeholder="$t('equipment.cabinet.district')">
                <el-option
                  v-for="item in formAreaList"
                  :key="item.regionId"
                  :label="item.nameCn"
                  :value="item.regionId"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-input v-model="form.location" :placeholder="$t('equipment.cabinet.robotAddress')" />
        </el-form-item>
        <!-- <el-form-item label="是否接入OTA" prop="ota">
          <el-select v-model="form.ota" placeholder="是否接入OTA">
            <el-option
              v-for="item in options"
              :key="item.name"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('equipment.cabinet.robotProdTime')">
          <el-date-picker
            v-model="form.produceTime"
            type="datetime"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('equipment.cabinet.robotProdTime')"
          />
        </el-form-item>
        <el-form-item :label="$t('equipment.cabinet.robotOutboundTime')">
          <el-date-picker
            v-model="form.ledgerBatch"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('equipment.cabinet.robotOutboundTime')"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" size="small" @click="onSubmit">{{$t('activity.list.confirm')}}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from "@/utils/request";
import { common } from "../../common/mixin";
import { formatTime } from "../../common/utils";
import Table from "@/components/table/index";
import Filter from "@/components/table/filter";
import { ElMessage } from "element-plus";
import { standard } from '@/common/constant';
import { computed } from "vue";
import { useStore } from "vuex"
import { useRouter, useRoute } from 'vue-router'
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
export default {
  components: {
    Table,
    Filter,
  },
  mixins: [common],
  data() {
    const store = useStore()
    const route = useRoute()
    const deviceType = route.query.deviceType
    const deviceCode = route.query.deviceCode
    return {
      dialogFormVisible: false,
      formRef: null,
      form: {
        id: '',
        robotId: '',
        cabNo: '',
        robotName: '',
        // productName: '',
        // modelName: '',
        country: 80,
        province: '',
        city: '',
        area: '',
        location: '',
        ota: 0,
        produceTime: '',
        ledgerBatch: '',
      },
      formRules: {
        robotId: {
          required: true,
          message: this.$t('equipment.robot.enterRobotCode'),
          trigger: 'blur',
        },
        // modelName: {
        //   required: true,
        //   message: '请输入规格型号',
        //   trigger: 'blur',
        // },
        // ota: {
        //   required: true,
        //   message: '请选择是否接入OTA',
        //   trigger: 'change'
        // }
      },
      cabinetList: [],
      params: [
        {
          key: "robotSn",
          value: deviceType == 1 ? deviceCode : '',
          label: this.$t('eIoT.transmit.robotCode'),
        },
        {
          key: "robotName",
          value: '',
          label: this.$t('eIoT.transmit.robotName'),
        },
        {
          key: "edgeCode",
          value: deviceType == 2 ? deviceCode : '',
          label: this.$t('eIoT.deviceConfig.edgeCode'),
        },
        {
          key: "fileName",
          value: '',
          label: this.$t('eIoT.transmit.dataPackageName'),
        },
        {
          type: "Select",
          key: "uploadMethod",
          value: '',
          label: this.$t('eIoT.deviceConfig.uploadMethod'),
          options: {
            data: [{ name: this.$t('eIoT.deviceConfig.directConnection'), value: 0 }, { name: this.$t('eIoT.deviceConfig.edgeEndpoint'), value: 1 }],
            label: "name",
            value: "value"
          }
        },
        // {
        //   type: "Date",
        //   key: "dateRange",
        //   value: [],
        //   label: this.$t('equipment.cabinet.outboundTime'),
        //   options: {
        //     "type": "datetimerange",
        //     "format": "YYYY-MM-DD HH:mm:ss",
        //     "value-format": "YYYY-MM-DD HH:mm:ss",
        //     "range-separator": this.$t('activity.detail.to'),
        //     "start-placeholder": this.$t('activity.list.startDate'),
        //     "end-placeholder": this.$t('activity.list.endDate'),
        //     "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]
        //   }
        // },
      ],
      query: {
        robotSn: deviceType == 1 ? deviceCode : '',
        edgeCode: deviceType == 2 ? deviceCode : ''
      },
      page: 1,
      size: 10,
      total: 0,
      tableDataList: [],
      countryList: [
        {
          nameCn: this.$t('equipment.cabinet.china'),
          nameEn: "China",
          regionId: '80',
        },
      ],
      provinceList: [],
      cityList: [],
      areaList: [],
      formCityList: [],
      formAreaList: [],
      robotStatusList: [], // 机器人状态下拉列表
      industryList: [], // 行业下拉列表
      options: [
        {
          id: true,
          name: this.$t('activity.detail.yes'),
        },
        {
          id: false,
          name: this.$t('activity.detail.no'),
        },
      ],
      batchDataList: [], // 表格多选
      userInfo: {},
      standard: standard,
      curLang: computed(() => store.state.lang),
      authList: JSON.parse(window.localStorage.getItem('authList')),

    };
  },
  watch: {
    "query.province": function(value, old) {
      if (value && value !== old) {
        console.log("province", value);
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.cityList = data;
        });
      }
    },
    "query.city": function(value, old) {
      if (value && value !== old) {
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.areaList = data;
        });
      }
    },
    "form.province": function(value, old) {
      if (value && value !== old) {
        console.log("province", value);
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.formCityList = data;
        });
      }
    },
    "form.city": function(value, old) {
      if (value && value !== old) {
        request("getArea", {
          parentId: Number(value),
        }).then((data) => {
          this.formAreaList = data;
        });
      }
    },
  },
  created() {
    this.getData();
    this.getDataMap();
    try {
      const userInfo = window.localStorage.getItem('userInfo')
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo) || {}
      }
    } catch (error) {
      console.error(error)
    }
  },
  mounted() {
    // this.tableDataList = robotList({}).then(data => {
    //   this.tableDataList = data
    // })
    // this.$store.dispatch('status/robot', {})
    // .then(data => {
    //   console.log(data)
    // })
    // robotList({}).then(data => {
    //   this.tableDataList = data
    // })
  },
  methods: {
    getData() {
      request("uploadingList", {
        ...this.query,
        page: this.page,
        size: this.size,
      })
        .then((data) => {
          // this.tableDataList = data || [];
          // this.total = data.length;
          this.tableDataList = data.records;
          this.total = data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDataMap() {
      try {
        request("getArea", {
          parentId: 1,
        }).then((data) => {
          this.provinceList = data;
        });
        request("getRobotStatusMap").then((data) => {
          this.robotStatusList = data;
        });
        request("getIndustryList").then((data) => {
          this.industryList = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    searchData(data) {
      this.query = data;
      this.getData();
    },
    updatePage(page, size) {
      this.page = page || 1;
      this.size = size || 10;
      this.getData();
    },
    // selectable (row) {
    //   if (row.isShow == 1) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    // handleSelect(data) {
    //   this.batchDataList = data.map((item)=>{
    //     return item.id
    //   })
    // },
    addNewRobot() {
      for (let key of Object.keys(this.form)) {
        this.form[key] = '';
      }
      this.dialogFormVisible = true;
      console.log(this.form);
    },
    editRobot(data) {
      for (let key of Object.keys(this.form)) {
        if (typeof data[key] != 'undefined') {
          this.form[key] = data[key];
        } else {
          this.form[key] = '';
        }
      }
      this.form.id = data.id;
      this.dialogFormVisible = true;
      this.cabinetQuery()
      console.log(this.form);
      return;
    },
    async onSubmit() {
      try {
        this.$refs.formRef && await this.$refs.formRef.validate()
        const api =  this.form.id ? 'updateRobot' : 'addRobot'
        await request(api, this.form)
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.dialogFormVisible = false
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },

    onCancel() {
      this.dialogFormVisible = false;
    },
    async setOtaIsShow() {
      try {
        await request('setOtaIsShow', {
          ids: this.batchDataList
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    async cancelOtaIsShow(row) {
      try {
        await request('cancelOtaIsShow', {
          id: row.id
        })
        ElMessage({
          showClose: true,
          type: "success",
          message: this.$t('activity.list.submitSuccess')
        })
        this.getData()
      } catch (error) {
        console.error(error)
      }
    },
    async cabinetQuery (name) {
      try {
        this.cabinetList = []
        const res = await request('getAssociationCabinet', {
          id: this.form.id,
          cabinetId: name
        })
        this.cabinetList = (res || []).slice(0, 20)
      } catch (error) {
        console.error(error)
      }
    },
    dateChange() {
      console.log("dateChange: ", this.dateRange);
    },
    formatproduceTime(date) {
      console.log(date);
      if (date) {
        this.form.produceTime = formatTime(date);
      }
    },
    formatledgerBatch(date) {
      console.log(date);
      if (date) {
        this.form.ledgerBatch = formatTime(date);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
